export default __webpack_public_path__ + "static/media/065.613b1ea4.jpg";